import * as icons from 'src/app/services/icon.library';
import { Component, inject } from '@angular/core';
import { Wrapper } from 'src/app/components/wrapper.component';
import { UserSettings } from '../../../globals/store/user.data';
import { IconComponent } from '../components/icon/icon.component';
import { ActionButtonComponent } from '../components/nav-bar/action-button.component';
import { SettingsService } from './settings.service';
import { settingsFeature } from '../store/settings.era';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'icon-viewer-component',
    template: `
<div id="actions-holder" *ngIf="!!userSettings">
  <action-button *ngIf="!!userSettings.hiddenTips?.length"
  [text]="'Reset Hide Tips (Show all tips again)'" 
  (click)="resetShowTips()"
  ></action-button>
  <action-button *ngIf="hasColumnSettings"
  [text]="'Delete All Column Preferences'" 
  (click)="deleteColumnPreferences()"
  ></action-button>
</div>
<div class="wrap920">
  <div class="icon-holder" *ngFor="let icon of icons">
    <icon [icon]="icon"></icon>
    <div class="icon-name">{{ icon }}</div>
  </div>
</div>
`,
    styles: [`
  #actions-holder { display: flex; margin: 20px 50px 0px; }
  action-button { margin: 0 5px; }
  .wrap920 { display: flex; flex-wrap: wrap; background: white; justify-content: space-evenly; }
  .icon-holder { padding: 20px; margin: 20px; display: flex; flex-direction: column;   align-items: center; height: 100px; width: 150px; }
  icon { color: #11b8c1; width: 48px; height: 48px; font-size: 48px; }
  .icon-name { margin-top: 10px; font-size: 10px; font-weight: bold; }
`],
    styleUrls: ['../page.scss'],
    imports: [IconComponent, CommonModule, ActionButtonComponent],
    standalone: true,
})
export class IconViewerComponent extends Wrapper<IconViewerComponent> {
  icons = Object.keys(icons).sort()
  userSettings: UserSettings
  hasColumnSettings = false
  // settingsService = inject(SettingsService)

  constructor() {
    super()
    this.subCallback(this.store.select(settingsFeature.selectUser), settings => {
      this.userSettings = settings
      this.hasColumnSettings = Object.keys(settings)
                                    .filter(s => s.includes('_column'))
                                    .some(s => !!settings[s])
    })
  }

  resetShowTips() {
    this.settingsService.resetTips()
  }

  deleteColumnPreferences() {
    this.settingsService.resetColumnDefaults()
  }
  

}

